import { render, staticRenderFns } from "./60.vue?vue&type=template&id=6d9994bb&scoped=true&"
var script = {}
import style0 from "./60.vue?vue&type=style&index=0&id=6d9994bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9994bb",
  null
  
)

export default component.exports